var React = require('react');

function Hart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.07974 16.7646L7.83097 15.5086C3.19714 11.3708 0.168091 8.58102 0.168091 5.15948C0.168091 2.37529 2.30925 0.214355 5.06715 0.214355C6.58671 0.214355 8.10062 0.934894 9.07974 2.10338C10.0588 0.934876 11.5728 0.214355 13.0923 0.214355C15.8502 0.214355 17.9914 2.37529 17.9914 5.15948C17.9914 8.58093 14.9623 11.3707 10.3285 15.5086L9.07974 16.7646Z","fill":"#FF553C"}));
}

Hart.defaultProps = {"className":"svg-icon svg-icon--heart","width":"18","height":"17","viewBox":"0 0 18 17","fill":"none"};

module.exports = Hart;

Hart.default = Hart;
